import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const $ = jQuery.noConflict()

class MobileHeader {
    constructor(trigger = '.btn-hamburger', pbody = 'body', listParent = '.menu-item-has-children > a, .menu-item-type-post_type > a', submenuTitle = '.sub-menu__title') {
        this.trigger = trigger
        this.pbody = pbody
        this.listParent = listParent
        this.submenuTitle = submenuTitle
    }

    init() {
        $(this.trigger).on('click', this.setNavState)
        $(this.listParent).on('click', this.setListState)
        $(this.submenuTitle).on('click', event => {
            $(event.target).parent().prev().click()
        })
        this.resized()
        this.destinationTabs()
    }

    setNavState(e) {
        e.preventDefault()
        const body = $('body')

        if ($(this).hasClass('open')) {
            MobileHeader.hideWrapper(this, body)
        } else {
            MobileHeader.showWrapper(this, body)
        }
    }

    setListState(e) {
        e.preventDefault()
        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
            $(this).closest('.main-header__nav-mobile').addClass('submenu-active');
        } else {
            $(this).removeClass('open');
            $(this).closest('.main-header__nav-mobile').removeClass('submenu-active');
        }
    }

    static hideWrapper(el, body) {
        $(el).removeClass('open')
        body.removeClass('overlayed')
        $(el).next().removeClass('active')
        $('.menu-item-has-children > a, .menu-item-type-post_type > a').removeClass('open')
        $('.mobile-mega-menu-tabs__content-tab').hide()
        enablePageScroll()
    }

    static showWrapper(el, body) {
        $(el).addClass('open')
        body.addClass('overlayed')
        $(el).next().addClass('active')
        disablePageScroll()
    }

    resized() {
        if (!$(this.trigger).is(':visible') && $(this.trigger).hasClass('open')) {
            MobileHeader.hideWrapper(this.trigger, $(this.pbody))
        }

        $('.main-header__nav-mobile--wrapper').css({
            'height': `${window.innerHeight - $('.main-header').height()}px`,
        })
    }

    hideOutsideClick(e) {
        if ($(this.trigger).length > 0 && $(this.trigger).hasClass('open')) {
            const container = $('.main-header')
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                MobileHeader.hideWrapper(this.trigger, $(this.pbody))
            }
        }
    }

    destinationTabs() {
        $('.mobile-mega-menu-tabs__tab').on('click', event => {
            const tab = $(event.currentTarget)
            const content = tab.closest('.mobile-mega-menu-tabs').find(`.mobile-mega-menu-tabs__content-tab:nth-child(${tab.index() + 1})`)
            content.show()
        })

        $('.mobile-mega-menu-tabs__content-title').on('click', event => {
            $(event.currentTarget).parent().hide()
        })
    }
}

export default new MobileHeader()
